import FAQ, { TypeType } from 'components/faq/FAQ';
import LandingHero from 'components/landingHero/LandingHero';
import Quote from 'components/quote/Quote';
import faqs from 'modules/faqs';
import { userBasicInfoPublicPages } from 'modules/graphqlQueries';
import { useRouter } from 'next/router';
import {
  Bullet,
  BulletPoint,
  BulletsPoints,
  BulletText,
  ButtonStyled,
  QuoteWrapper,
  ScreenImage,
  SectionsTitle,
  SectionsTitleWrapper,
  SubTitle,
  TitleLine,
  WhatWeProvide,
  WhatWeProvideContent,
} from 'styles/service-suppliers.styles';

import Layout from '../components/layout/Layout';
import { useLoadData } from '../modules/useLoadData';
import { UserType } from '../types/UserTypes';

const getQuery = (userId) => `{
  user(_id: "${userId}") {
    ${userBasicInfoPublicPages}
  }
}`;

const Suppliers = (): JSX.Element => {
  const router = useRouter();

  const {
    isLoading,
    response: {
      data: { user },
    },
  } = useLoadData(getQuery);

  const faqsServiceSuppliers = faqs.filter((faq) =>
    faq.type.includes(TypeType.SUPPLIER)
  );

  return (
    <Layout user={user as UserType} isLoading={isLoading}>
      <LandingHero
        image="/serviceSuppliers.webp"
        title="Upgrade your business operations"
        text="Promote your company for FREE and simplify your service arrangements"
        buttons={[
          {
            kind: 'request',
            text: 'Contact us',
            onClick: () => router.push('/contact'),
          },
        ]}
      />
      <WhatWeProvide>
        <SectionsTitleWrapper>
          <SectionsTitle color="black">What we provide</SectionsTitle>
          <SubTitle>TO SERVICE SUPPLIERS</SubTitle>
        </SectionsTitleWrapper>
        <TitleLine color="gray" />
        <WhatWeProvideContent>
          <BulletsPoints>
            <BulletPoint>
              <Bullet>1</Bullet>
              <BulletText>
                Visibility to a high number of prospective customers
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>2</Bullet>
              <BulletText>
                Simplification and reduction of the time required for service
                arrangement
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>3</Bullet>
              <BulletText>Effective, low cost marketing tool</BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>4</Bullet>
              <BulletText>
                Competitive bidding based on ranking system
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>5</Bullet>
              <BulletText>
                Time and resources allocation efficiencies
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>6</Bullet>
              <BulletText>Data analytics and benchmarking</BulletText>
            </BulletPoint>
          </BulletsPoints>
          <ScreenImage src="/screen.png" />
        </WhatWeProvideContent>
        {/* <Quote title="Our Vision">
          Bringing digital transformation to the industry by ultimately fully
          integrating our Platform in the Managment System of shipping companies
          towards creating new and sustainable processes in service provision.
        </Quote> */}
      </WhatWeProvide>
      <FAQ faqs={faqsServiceSuppliers} />
      <QuoteWrapper>
        <Quote title="Benefits">
          bid2board ensures quality and efficiency, reduces the time required to
          arrange service and enhances visibility through a simple and automated
          platform
        </Quote>
        <ButtonStyled
          kind="primary"
          text="Contact us"
          onClick={() => router.push('/contact')}
          icon="rightArrow"
        />
      </QuoteWrapper>
    </Layout>
  );
};

export default Suppliers;
